<!-- <div class="p-20" fxLayout="column" fxLayoutAlign="start stretch" > -->
<div class="p-20" fxLayout="row wrap" fxLayoutAlign="center">
    <ng-container *ngIf="cargando">
        <div fxLayout="column" fxLayoutAlign="space-between center">
            <mat-spinner *ngIf="false"></mat-spinner><div class="spinnerCGO"></div>
            <h1>{{'CIERRE.CARGANDO' | translate}}</h1>
        </div>
    </ng-container>

    <ng-container *ngIf="!flagCierre && !cargando">
        <div fxLayout="column" fxLayoutAlign="start center" fxFlex="100">

            <h1>{{'CIERRE.LABEL1' | translate}}</h1>
            <ng-container *ngIf="typeSurvey1 && typeSurvey2">
                <mat-progress-bar mode="determinate" value="{{ porcentaje2 }}" style="height: 20px; " *ngIf="typeSurvey1 && typeSurvey2"></mat-progress-bar>
                <h3 *ngIf="typeSurvey1 && typeSurvey2">Avance -50: {{ porcentaje2 }}%</h3>
            </ng-container>


            <mat-progress-bar mode="determinate" value="{{ porcentaje }}" style="height: 20px;"></mat-progress-bar>
            <h3>{{avaneLabel}} {{ porcentaje }}%</h3>
            <!-- <h1>{{'CIERRE.LABEL2' | translate}}</h1>
            <a href="{{ url }}" target="_blank">{{ url }}</a>
            <button *ngIf="!flagCierre" mat-raised-button color="accent" (click)="showAlert();" class="mt-20">
              {{'CIERRE.BTN_CIERRE' | translate}}
            </button> -->

        </div>

        <div class="mt-40" fxFlex="100" fxLayout="row" fxLayoutAlign="space-around stretch" [@animate]="{value:'*',params:{delay:'250ms', y:'25px'}}">
            <div class="cardInfo mat-elevation-z3 p-20" fxLayout="column" fxLayoutAlign="start stretch">
                <h2 class="mt-0">{{'CIERRE.LABEL2' | translate}}</h2>
                <mat-divider></mat-divider>
                <div class="mt-20 mb-20">
                    <div class="h4 secondary-text mb-20">{{'CIERRE.LINK' | translate}}</div>

                </div>
                <div class="mt-20" fxFlex="60" fxLayout="column" fxLayoutAlign="space-between stretch" *ngIf="!Cargandocorreo">
                    <button mat-raised-button class="mb-20 accent btnLabel" (click)="typeSurvey(1)" [routerLink]="'/portalControl/'" *ngIf="typeSurvey1 && !typeSurvey2">
                        {{'CIERRE.PORTAL.LABEL01' | translate}} -50
                        <mat-icon class="ml-20 btnIcon">poll</mat-icon>
                    </button>

                    <button mat-raised-button class="mb-20 accent btnLabel" (click)="typeSurvey(2)" [routerLink]="'/portalControl/'" *ngIf="typeSurvey2 && !typeSurvey1">
                        {{'CIERRE.PORTAL.LABEL01' | translate}} +50
                        <mat-icon class="ml-20 btnIcon">poll</mat-icon>
                    </button>

                    <button mat-raised-button class="mb-20 accent btnLabel" (click)="typeSurvey(1)" [routerLink]="'/portalControl/'" *ngIf="typeSurvey1 && typeSurvey2">
                        {{'CIERRE.PORTAL.LABEL01' | translate}} -50
                        <mat-icon class="ml-20 btnIcon">poll</mat-icon>
                    </button>


                    <button mat-raised-button class="mb-20 accent btnLabel" (click)="typeSurvey(2)" [routerLink]="'/portalControl/'" *ngIf="typeSurvey2 && typeSurvey1">
                        {{'CIERRE.PORTAL.LABEL01' | translate}} +50
                        <mat-icon class="ml-20 btnIcon">poll</mat-icon>
                    </button>

                    <button mat-raised-button class="mb-20 accent btnLabel" (click)="sendReminder(1)" *ngIf="typeSurvey1 && !Finalizada1">
                        {{'CIERRE.CIERRE.REMANDER' | translate}}  -50
                        <mat-icon class="ml-20 btnIcon">email</mat-icon>
                    </button>
                    <button mat-raised-button class="mb-20 accent btnLabel" (click)="sendReminder(2)" *ngIf="typeSurvey2 && !Finalizada2">
                        {{'CIERRE.CIERRE.REMANDER' | translate}}  +50
                        <mat-icon class="ml-20 btnIcon">email</mat-icon>
                    </button>

                    <!--<button mat-raised-button class="mb-20 accent" (click)="addColaboradores()" *ngIf="typeSurvey2 && !Finalizada2">
                        Agregar nuevos colaboradores
                        <mat-icon class="ml-20">email</mat-icon>
                    </button>-->

                </div>
                <div class="mt-20" fxFlex="60" fxLayout="column" fxLayoutAlign="space-between stretch" *ngIf="Cargandocorreo">
                    <div fxLayout="column" fxLayoutAlign="space-between center">
                        <mat-spinner *ngIf="false"></mat-spinner><div class="spinnerCGO"></div>
                        <h3>{{'CIERRE.CARGANDOCORREO' | translate}}</h3>
                    </div>
                </div>
            </div>

        </div>

    </ng-container>

    <ng-container *ngIf="flagCierre">

        <!--<div class="statusDiv" [@animate]="{value:'*',params:{delay:'250ms', y:'25px'}}">
            <div class="roundEdg done mat-elevation-z4 pr-20 pl-20" fxLayout="row" fxLayoutAlign="space-between center">
                <h2>{{'CIERRE.COMPLETO.TAG' | translate}}</h2>
                <mat-icon class="ml-20 s-40">check_circle</mat-icon>
            </div>
        </div>-->

        <!--<div class="mt-40" fxFlex="100" fxLayout="row" fxLayoutAlign="center stretch" [@animate]="{value:'*',params:{delay:'250ms', y:'25px'}}">
            <div class="mat-elevation-z3 p-20" fxFlex="60" fxLayout="column" fxLayoutAlign="start stretch">
                <h2 class="mt-0">{{'CIERRE.COMPLETO.CARDTIT' | translate}}</h2>
                <mat-divider></mat-divider>
                <div class="mt-20 mb-20">
                    <div class="h4 secondary-text mb-20">{{'CIERRE.COMPLETO.LINK' | translate}}</div>
                    <a href="{{ url }}" target="_blank">{{ url }}</a>
                </div>
            </div>
        </div>-->
    </ng-container>




</div>
